import React, { useEffect, useState } from "react";
import styles from "./StudentData.module.css";
import { db } from "./firebase";
import { collection, query, where, getDocs } from "firebase/firestore";

const StudentData = () => {
  const [selectedCohort, setSelectedCohort] = useState("");
  const [students, setStudents] = useState([]);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [studentLogs, setStudentLogs] = useState([]);
  const [skillTallies, setSkillTallies] = useState({});
const [groupedSkills, setGroupedSkills] = useState({});
const [icdTallies, setIcdTallies] = useState({});
const [totalEncounters, setTotalEncounters] = useState(0);
const [totalExposures, setTotalExposures] = useState(0);
const [totalHours, setTotalHours] = useState(0);
const [visitTallies, setVisitTallies] = useState({});
const [ageGroupTallies, setAgeGroupTallies] = useState({});
const [cptTallies, setCptTallies] = useState({});




  const sections = [
  {
    title: "Preliminary Testing & History",
    skills: [
      "Chief Complaint (CC) & History of Present Illness (HPI)",
      "Medical, Ocular, and Family History",
      "Visual Acuity",
      "Pupillary Testing",
      "Extraocular Motilities (EOMs)",
      "Cover Test",
      "Confrontation Visual Fields",
      "Color Vision & Stereopsis",
      "Lensometry",
      "Autorefraction / Keratometry",
      "Intraocular Pressure (Tonometry)"
    ]
  },
  {
    title: "Refraction",
    skills: [
      "Retinoscopy",
      "Autorefraction",
      "Subjective Refraction",
      "Binocular Balance"
    ]
  },
  {
    title: "Ocular Health Evaluation",
    skills: [
      "External Exam (lids, lashes, adnexa)",
      "Slit Lamp Exam (cornea, anterior chamber, iris, lens)",
      "Fundus Exam (optic nerve, retina, macula)—often done with dilation",
      "Gonioscopy (if glaucoma suspected)"
    ]
  },
  {
    title: "Special Testing",
    skills: [
      "Optical Coherence Tomography (OCT)",
      "Visual Fields",
      "Tear Film Testing (TBUT, Schirmer’s)",
      "Corneal Topography / Pachymetry",
      "Fundus Photography",
      "Additional binocular vision or accommodative tests",
      "Others as needed based on findings"
    ]
  },
  {
    title: "Assessment, Plan & Patient Education",
    skills: [
      "Final Diagnosis and Management Plan",
      "Prescribe glasses/contact lenses",
      "Recommend medications or therapy",
      "Patient education (ocular health, treatment plan, follow-up)",
      "Referral to a specialist if needed"
    ]
  }
];

const uncommonSkills = {
  "Preliminary Testing & History": [
    "Near Point of Convergence (NPC)",
    "Blood Pressure measurement",
    "Red Cap Desaturation",
    "Heterophoria Testing",
    "Dark Adaptation Screening"
  ],
  "Refraction": [
    "Cycloplegic Refraction",
    "Over-plus and Fogging Techniques",
    "MEM Retinoscopy"
  ],
  "Ocular Health Evaluation": [
    "Corneal Staining",
    "Lid Eversion & Meibomian Gland Expression",
    "Seidel Test"
  ],
  "Special Testing": [
    "B-scan Ultrasonography",
    "Contrast Sensitivity Testing"
  ],
  "Assessment, Plan & Patient Education": [
    "Specialty Contact Lens Fitting",
    "Low Vision Rehabilitation",
    "Minor In-Office Procedures"
  ]
};


const fetchLogsForStudent = async (student) => {
  console.log("Fetching logs for:", student.email, "| Firestore ID:", student.id);


  try {
    const logsRef = collection(db, "users", student.id, "logs");
    const snapshot = await getDocs(logsRef);

    const skillsCount = {};
    const visitTypeCount = {};
    const cptCount = {};
    const icdCount = {};
    const ageGroupCount = {};

    const mergedSkillSections = {};
    let minutesTotal = 0;
let encounterCount = 0;
let exposureCount = 0;


    // Merge skill sections
    sections.forEach((section) => {
      section.skills.forEach((skill) => {
        mergedSkillSections[skill] = section.title;
      });
    });

    Object.entries(uncommonSkills).forEach(([section, skills]) => {
      skills.forEach((skill) => {
        mergedSkillSections[skill] = section;
      });
    });

    snapshot.forEach((doc) => {
      const data = doc.data();

      // 🧍 Count Encounters
  if (data.involvement?.includes("Encounter")) {
    encounterCount++;
  }

  // 👥 Count Exposures
  if (data.involvement?.includes("Exposure")) {
    exposureCount++;
  }

  // ⏱️ Sum Minutes
  minutesTotal += Number(data.duration) || 0;



      if (Array.isArray(data.skills)) {
        data.skills.forEach((skill) => {
          skillsCount[skill] = (skillsCount[skill] || 0) + 1;
        });
      }

      if (data.visitType) {
        visitTypeCount[data.visitType.trim()] = (visitTypeCount[data.visitType.trim()] || 0) + 1;
      }

      // Age Group
if (data.ageGroup) {
  ageGroupCount[data.ageGroup.trim()] = (ageGroupCount[data.ageGroup.trim()] || 0) + (Number(data.duration) || 0);
}

      if (Array.isArray(data.cptCodes)) {
        data.cptCodes.forEach((code) => {
          cptCount[code] = (cptCount[code] || 0) + 1;
        });
      }

      if (Array.isArray(data.diagnoses)) {
        data.diagnoses.forEach((code) => {
          icdCount[code] = (icdCount[code] || 0) + 1;
        });
      }
    });

        const grouped = {};
    Object.entries(skillsCount).forEach(([skill, count]) => {
      const section = mergedSkillSections[skill] || "Uncategorized";
      if (!grouped[section]) grouped[section] = {};
      grouped[section][skill] = count;
    });

    setSkillTallies(skillsCount);
    setGroupedSkills(grouped);
    setVisitTallies(visitTypeCount);
    setCptTallies(cptCount);
    setIcdTallies(icdCount);
    setVisitTallies(visitTypeCount);
setAgeGroupTallies(ageGroupCount);
setCptTallies(cptCount);


    // ✅ Place here INSIDE try block, before the closing }
    setTotalEncounters(encounterCount);
    setTotalExposures(exposureCount);
    setTotalHours((minutesTotal / 60).toFixed(1));

  } catch (err) {
    console.error("🔥 Error loading student logs:", err);
  }

};



  // Fetch students based on cohort
  useEffect(() => {
    const fetchStudents = async () => {
      if (!selectedCohort) return;
      const q = query(collection(db, "users"), where("cohort", "==", selectedCohort));
      const snapshot = await getDocs(q);
      const users = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setStudents(users);
    };
    fetchStudents();
  }, [selectedCohort]);

  useEffect(() => {
  if (selectedStudent?.id) {
    console.log("📣 Fetching logs for:", selectedStudent.id);
    fetchLogsForStudent(selectedStudent);

  }
}, [selectedStudent]);


  return (
  <div className={styles.studentDataContainer}>
    <h2 className={styles.title}>
      📊 <span>Student Data</span>
    </h2>

    {/* 🎓 Cohort Filter */}
    <div className={styles.filterRow}>
      <div className={styles.filterGroup}>
        <label htmlFor="cohortSelect">🎓 Select Cohort</label>
        <select
          id="cohortSelect"
          value={selectedCohort}
          onChange={(e) => {
            setSelectedCohort(e.target.value);
            setSelectedStudent(null);
            setStudentLogs([]);
          }}
          className={styles.dropdown}
        >
          <option value="">-- Choose a Cohort --</option>
          <option value="OD-1">OD-1</option>
          <option value="OD-2">OD-2</option>
          <option value="OD-3">OD-3</option>
          <option value="OD-4">OD-4</option>
        </select>
      </div>

      {/* 🧑‍🎓 Student Selector */}
      {selectedCohort && (
        <div className={styles.filterGroup}>
          <label htmlFor="studentSelect">🧑‍🎓 Select Student</label>
          <select
            id="studentSelect"
            value={selectedStudent?.id || ""}
            onChange={(e) => {
              const student = students.find((s) => s.id === e.target.value);
              setSelectedStudent(student);
            }}
            className={styles.dropdown}
          >
            <option value="">-- Choose a Student --</option>
            {students.map((student) => (
              <option key={student.id} value={student.id}>
                {student.name || student.email}
              </option>
            ))}
          </select>
        </div>
      )}
    </div>

    {/* 🧑‍⚕️ Student Info Card - below filters, centered */}
    {selectedStudent && (
      <div style={{ display: "flex", justifyContent: "center", margin: "1.5rem 0" }}>
        <div className={styles.studentHeader}>
          <div className={styles.studentInfo}>
            <div className={styles.studentIcon}>🧑‍⚕️</div>
            <div>
              <h2 className={styles.studentName}>{selectedStudent.name || selectedStudent.email}</h2>
              <p className={styles.studentCohort}>
                Cohort: <strong>{selectedStudent.cohort}</strong>
              </p>
            </div>
          </div>
        </div>
      </div>
    )}

    {/* Summary Boxes */}
    <div style={{ display: "flex", gap: "1.5rem", marginBottom: "1.5rem", flexWrap: "wrap" }}>
      <div style={{
        flex: "1",
        minWidth: "150px",
        background: "#e0f7fa",
        padding: "16px",
        borderRadius: "10px",
        textAlign: "center",
        boxShadow: "0 1px 4px rgba(0,0,0,0.08)"
      }}>
        <h4 style={{ margin: 0, color: "#00796b" }}>Encounters</h4>
        <p style={{ fontSize: "1.5rem", fontWeight: "bold", margin: 0 }}>{totalEncounters}</p>
      </div>

      <div style={{
        flex: "1",
        minWidth: "150px",
        background: "#fce4ec",
        padding: "16px",
        borderRadius: "10px",
        textAlign: "center",
        boxShadow: "0 1px 4px rgba(0,0,0,0.08)"
      }}>
        <h4 style={{ margin: 0, color: "#ad1457" }}>Exposures</h4>
        <p style={{ fontSize: "1.5rem", fontWeight: "bold", margin: 0 }}>{totalExposures}</p>
      </div>

      <div style={{
        flex: "1",
        minWidth: "150px",
        background: "#fff3e0",
        padding: "16px",
        borderRadius: "10px",
        textAlign: "center",
        boxShadow: "0 1px 4px rgba(0,0,0,0.08)"
      }}>
        <h4 style={{ margin: 0, color: "#ef6c00" }}>Hours</h4>
        <p style={{ fontSize: "1.5rem", fontWeight: "bold", margin: 0 }}>{totalHours}</p>
      </div>
    </div>


{groupedSkills && (
  <div className={styles.breakdownGrid}>
    {/* Skill Sections */}
    {Object.entries(groupedSkills).map(([section, skills]) => (
      <div key={section} className={styles.breakdownCard}>
        <h4 className={styles.breakdownTitle}>{section}</h4>
        <ul style={{ listStyle: "none", paddingLeft: 0, margin: 0 }}>
          {Object.entries(skills).map(([skill, count]) => (
            <li
              key={skill}
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "0.5rem",
                color: count < 5 ? "#d32f2f" : "#333",
                fontWeight: count < 5 ? "bold" : "normal",
              }}
            >
              <span>{skill}</span>
              <span>{count}</span>
            </li>
          ))}
        </ul>
      </div>
    ))}

    {/* Visit Type Breakdown */}
    {visitTallies && Object.keys(visitTallies).length > 0 && (
      <div className={styles.breakdownCard}>
        <h3 className={styles.breakdownTitle}>📋 Visit Type Breakdown</h3>
        {Object.entries(visitTallies).map(([type, count]) => (
          <div key={type} className={styles.breakdownItem}>
            <span className={styles.breakdownKey}>{type}</span>
            <span className={styles.breakdownValue}>{count}</span>
          </div>
        ))}
      </div>
    )}

    {/* Age Group Breakdown */}
    {ageGroupTallies && Object.keys(ageGroupTallies).length > 0 && (
      <div className={styles.breakdownCard}>
        <h3 className={styles.breakdownTitle}>👶 Age Group Time Distribution (Hours)</h3>
        {Object.entries(ageGroupTallies).map(([group, minutes]) => (
          <div key={group} className={styles.breakdownItem}>
            <span className={styles.breakdownKey}>{group}</span>
            <span className={styles.breakdownValue}>{(minutes / 60).toFixed(1)} hrs</span>
          </div>
        ))}
      </div>
    )}

    {/* CPT Breakdown */}
    {cptTallies && Object.keys(cptTallies).length > 0 && (
      <div className={styles.breakdownCard}>
        <h3 className={styles.breakdownTitle}>💉 CPT Code Breakdown</h3>
        {Object.entries(cptTallies).map(([code, count]) => (
          <div key={code} className={styles.breakdownItem}>
            <span className={styles.breakdownKey}>
  <strong>{code}</strong>
</span>

            <span className={styles.breakdownValue}>{count}</span>
          </div>
        ))}
      </div>
    )}
  </div>  
)}         


</div>
);      
};

export default StudentData;
